/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router-dom';

import { PortalSideMenu } from '../../PortalSideMenu';
import { useAppRouterStore } from '../../AppRouter';

import type { PortalSideMenuProps } from '../../PortalSideMenu';
import type { AppRouteItem } from '../../../stores/router';

export interface PortalBodyLayoutProps {
    currentPath: string;
    items: AppRouteItem[];
    children?: React.ReactElement;
    portalSideMenuProps?: Omit<PortalSideMenuProps, 'groups' | 'items' | 'children'>;
}

export const PortalBodyLayout: React.FC<PortalBodyLayoutProps> = observer(({ currentPath, items, children, portalSideMenuProps }) => {
    const routerStore = useAppRouterStore();
    const filteredItems = items.filter(({ hidden }) => !hidden);
    const { groups, items: navItems } = routerStore.getSideMenuContent(currentPath, filteredItems);

    return (
        <PortalSideMenu
            groups={groups}
            items={navItems}
            {...portalSideMenuProps}
        >
            {children ?? <Outlet key={currentPath} />}
        </PortalSideMenu>
    );
});
